<main>
    <section class="well bg-color">
        <div class="container">
            <h3 class="center">{{"PRODUCTS.WEOFFER" | translate}}</h3>
            <div class="row">
                <div class="grid_6"><img src="assets/images/Kaivuri irti part.png" alt=""></div>
                <div class="grid_6 mg-add">
                    <h5>{{"PRODUCTS.TITLE" | translate}}</h5>
                    <p class="txt1">{{"PRODUCTS.DESCRIPTION" | translate}}</p>
                    <br/>
                    <p class="txt1">{{"PRODUCTS.DESCPART2" | translate}}</p>
                    <br/>
                    <p class="txt1">{{"PRODUCTS.DESCPART3" | translate}}</p>
                </div>
            </div>
        </div>
    </section>
    <section class="well center">
        <div class="container">
            <h3>{{"PRODUCTS.OURPRODUCTS" | translate }}</h3>
            <div class="row off1">
                <div class="grid_4"><a (click)="redirect('/products/excavators')" class="img"><img class="square-image-home"
                                                                 src="assets/images/Kaivurit.jpg"
                                                                 alt=""><span>{{"NAV.KAIVURIT" | translate}}</span></a>
                </div>
                <div class="grid_4"><a (click)="redirect('/products/mulchers')" class="img"><img class="square-image-home"
                                                                 src="assets/images/Kelamurskaimet.jpg"
                                                                 alt=""><span>{{"NAV.VESAKKOMURSKIMET" | translate}}</span></a>
                </div>
                <div class="grid_4"><a (click)="redirect('/products/special')" class="img"><img class="square-image-home"
                                                                 src="assets/images/Erikoissovellukset-miina.jpg"
                                                                 alt=""><span>{{"NAV.ERIKOISSOVELLUS" | translate}}</span></a>
                </div>
            </div>
        </div>
    </section>
</main>
